import { Component, getAssetPath, h, Host, Prop } from '@stencil/core';

import wcShared from '@web-components/shared';

@Component({
  tag: 'chat-message-documentation-component',
  styleUrl: 'chat-message-documentation.scss',
  shadow: true,
})
export class ChatMessageDocumentation {
  @Prop() readonly documentationType: string;

  private documentationConfig = {
    jelastic_documentation: {
      description: wcShared?.translate(
        'La documentation en ligne de Jelastic repond egalement a beaucoup de questions. Pensez a la consulter.',
      ),
      url: 'https://docs.jelastic.com',
      logo: './../assets/icons/jelastic-line.svg',
    },
    swiss_backup_documentation: {
      description: wcShared?.translate(
        'La documentation en ligne de Acronis repond egalement a beaucoup de questions. Pensez a la consulter.',
      ),
      url: 'https://www.acronis.com/support/documentation/CyberProtectionService/#backup-and-recovery.html',
      logo: './../assets/icons/acronis.svg',
    },
  };

  render() {
    return (
      <Host>
        <p class="documentation-description">
          {this.documentationConfig[this.documentationType].description}
        </p>
        <a
          class="documentation-link"
          href={this.documentationConfig[this.documentationType].url}
          target="_blank"
        >
          <img
            class="documentation-link__logo"
            src={getAssetPath(this.documentationConfig[this.documentationType].logo)}
            alt="Jelastic"
          />
          <div class="flex align-items--center">
            <div class="documentation-link__text">
              {wcShared?.translate('Consulter la documentation')}
            </div>
            <img
              class="documentation-link__arrow"
              src={getAssetPath('./../assets/icons/chevron-right.svg')}
              alt={wcShared?.translate('Icon go to link')}
            />
          </div>
        </a>
      </Host>
    );
  }
}
